// Imports de librerías
import { Box3, Group, Raycaster, Vector2 } from 'three';
import gsap, { Power2, Power3 } from 'gsap';
import BezierEasing from 'bezier-easing';

// Imports internos
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';
import Image from '../_app/cuchillo/3D/Image';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { isMobile, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import Header from '../layout/Header';


export default class CircleSlider extends Group {
    static instance = null;
    static _alpha = 1;
    static data = {};
    static radio = 0;
    static radioShow = 0;
    static radioHide = 0;
    
    static easing = BezierEasing(0.69, 0.27, 0.43, 0.56);
    static easingX = BezierEasing(0.85, 0.45, 0.84, 0.54);

    static get alpha() {
        return this._alpha;
    }

    static set alpha(value) {
        this._alpha = value;
        const instance = this.getInstance();
       /* if (instance?.scroller) {
            instance.scroller._items.forEach(item => {
                item.image.material.uniforms.opacity.value = value;
            });
        }*/
    }
                
    static getInstance(dom) {
        if (!this.instance) {
            this.instance = new CircleSlider(dom);
        }
        return this.instance;
    }


    constructor(dom) {
        if (CircleSlider.instance) return CircleSlider.instance;
        super();

        this.dom = dom;
        this.meshes = [];
        this.total = 0;
        this.actual = null;
        this.isShow = false;
        this.visible = false;
        this.raycaster = new Raycaster();
        this.pointer = new Vector2();
        this.src404 = this.dom.dataset.src;
        
        this.radio = 0;
        this.radioShow = 0;
        this.radioHide = 0;
        this.scaleImage = 1;
        this.videosEnabled = false;
        this.hasSpeed = false;
        this._timer;
        this._indiceActual;
        this._videoActual;

        this.link;

        CircleSlider.instance = this;

        this.load();
        this.setupRaycaster();
        this.resize();
    }

    playVideo(video, indice) { 
        if(this._indiceActual == indice) return;

        clearTimeout(this.timer);

        if(this._videoActual) this._videoActual.stop();
        this._videoActual = video;
        this._indiceActual = indice

        this.timer = setTimeout(()=> {
            this._videoActual.play();
        }, 300);
    }

    load() {
        this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_X, {
            domResize: this.dom,
            container: this.dom,
            multiplicator: 1,
            itemClass: CircleSlider__Item,
            minSpeed: 2,
            inverted: false,
            gap: 0,
            hasVirtuaScroll: true,
        });
    }

    setupRaycaster() {
        this.meshes = this.scroller._items
            .map(item => item?.image?.mesh)
            .filter(Boolean);
    }

    show() {
        gsap.killTweensOf(CircleSlider);

        this.scroller.start();
        this.scroller.show();

        this.link = GetBy.id("HomeLink");

        this.visible = true;
        this.isShow = true;
        this.alpha = 0;

        for(let i=0; i<this.scroller.total_items; i++) {
            this.scroller._items[i].showAlpha();
        }

        CircleSlider.radio = CircleSlider.radioHide;
        this.scroller.options.minSpeed = 120;
        this.videosEnabled = true;

        gsap.to(CircleSlider, {radio:CircleSlider.radioShow , ease:Power3.easeOut, duration:.8, delay:0});
        gsap.to(this.scroller.options,{minSpeed:isSmartphone? 0 : 0, ease:Power2.easeOut, duration:2, delay:0, onComplete:()=> {
            
           /* for (let i = 0; i < this.scroller.total_items; i++) {
                const item = this.scroller._items[i];
                if(item.isShow3D) item.image.play();
            }*/
        }});

        gsap.to(CircleSlider, { alpha: 1, ease: Power2.easeIn, duration: 0.1 });
    }

    hide() {
        this.isShow = false;
        this.enabled = false;
        this.videosEnabled = false;
        
        gsap.killTweensOf([CircleSlider,this.scroller.options]);

        for(let i=0; i<this.scroller.total_items; i++) {
            this.scroller._items[i].hideAlpha(0);
        }

        gsap.to(this.scroller.options, {minSpeed: 80, ease: Power3.easeOut, duration: 1, delay:0 });
        gsap.to(CircleSlider, {radio:0, ease:Power2.easeIn, duration:.8, delay:0, onComplete:()=> {
            this.visible = false;
            this.scroller.hide();

            for (let i = 0; i < this.scroller.total_items; i++) {
                const item = this.scroller._items[i];
                if(item.isShow3D) item.image.stop();
            }
        }});
       /* gsap.to(CircleSlider, {
            alpha: 0,
            ease: Power2.easeIn,
            duration: 0.01,
            delay: 0.7,
            onComplete: () => {
                this.visible = false;
                this.scroller.hide();
            },
        });*/
    }

    checkHover() {
        if(!this.isShow) return;

        const mouse = Interaction.positions.mouse;
        this.pointer.set(
            (mouse.x / window.innerWidth) * 2 - 1,
            -(mouse.y / window.innerHeight) * 2 + 1
        );

        this.raycaster.setFromCamera(this.pointer, WebGLSketch.camera);
        const intersects = this.raycaster.intersectObjects(this.meshes, false);

        if (intersects.length > 0) {
            const uuid = intersects[0].object.uuid;
            if (this.actual !== uuid) {
                this.actual = uuid;
                const { title, url, isShow } = CircleSlider.data[uuid];
                Header.changeTitle(title, url);

            
                if(this.link) {
                    this.link.href = url;
                    this.link.style.pointerEvents = "all";
                }
            }
        } else {
            this.actual = null;
             if(this.link) this.link.style.pointerEvents = "none";
        }
    }

    loop() {
        if (!this.scroller.enabled) return;
        
        this.position.y = -CircleSlider.radio * .95;
        this.scroller.loop();

        CircleSlider.getInstance().hasSpeed = Math.abs(this.scroller.speed) > 1;
        if(!CircleSlider.getInstance().hasSpeed) this.checkHover();
    }

    resize() {
        CircleSlider.radio = 
            CircleSlider.radioShow = isSmartphone? Metrics.WIDTH * 3 : Metrics.WIDTH * .9;
        CircleSlider.radioHide = 0;//isSmartphone? Metrics.WIDTH * 6 : Metrics.WIDTH * 2;
        this.position.y = -this.radio * .95;
        this.scroller.resize();
    }
}


class CircleSlider__Item extends InfiniteScroll__Item {
    group = new Group();
    pivot = new Group();

    domImage;
    isReset = false;
    isShow3D = false;
    isBlocked = false;
    image;
    title;
    url;
    refWidth;
    offset = {};
    offsetPositionY = .55;
    modAspectRatio = 1;
    modSpeed = 1.859;

    alpha = 0;
    timer;
    
    distance = isSmartphone? 7 : 7;

    angleLimit = Functions.degreesToRadians(this.distance);
    angleOffset = Functions.degreesToRadians(((180 - this.distance)/2));

    angleStart = Functions.degreesToRadians(60);
    angleEnd = Functions.degreesToRadians(120);

    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis, false);
        this.domImage = GetBy.selector("span", this.dom)[0];
        this.image = new Image({dom:this.domImage, hasFreePosition:true});
        this.title = this.domImage.dataset.title;
        this.url = this.domImage.dataset.url;
        this.timer = null;
        
        // Calcular la altura real de la imagen
        const bbox = new Box3().setFromObject(this.image.mesh);
        const height = bbox.max.y - bbox.min.y;

        // Mover la imagen dentro del pivot para que su bottom quede en Y=0
        this.image.position.y = height / 2;

        this.pivot.add(this.image);
        this.group.add(this.pivot);

        CircleSlider.getInstance().add(this.group);
        CircleSlider.data[this.image.mesh.uuid] = this;

        this.image.visible = false;

        this.resize();
        this.reset();
    }

    reset() {
        if(this.isReset) return;
        this.isReset = true;
        
        this.offset = {
            y: 0,
            x: 0,
            rotation: {
                y0: Maths.maxminRandom(12, 4),
                x0: Maths.maxminRandom(12, 4),
                z0: Maths.maxminRandom(4, 2),
                y1: Maths.maxminRandom(12, 4),
                x1: Maths.maxminRandom(12, 4),
                z1: Maths.maxminRandom(4, 2),
                yMod: Math.random() > .5? 1 : -1,
                xMod: Math.random() > .5? -1 : 1,
                zMod: Math.random() > .5? -1 : 1,
            }
        }
    }

    drawHook() {
        this.move();
    }

    hideAlpha(delay=0) {
        this.alpha = 0;
        
        setTimeout(()=> {
            this.group.visible = false;
        }, delay + 600 + Maths.maxminRandom(100, 0));
    }

    showAlpha() {
        setTimeout(()=> {
            this.group.visible = true;
        }, Maths.maxminRandom(600, 0));
    }

    showItem() {
        if (this.isShow3D) return;

        this.isShow3D = true;
        this.isReset = false;
        this.image.visible = true;

        if(CircleSlider.getInstance().videosEnabled) {
            this.playVideo();
        }
    }

    hideItem() {
        if (!this.isShow3D) return;

        this.reset();
        this.isShow3D = false;
        this.stopVideo();
        this.image.visible = false;
    }

    playVideo() {
        if(isSmartphone) return;

        this.timer = setTimeout(()=> {
            this.image.play();
        }, 300);
    }

    stopVideo() {
        if(isSmartphone) return;

        if(this.timer) clearTimeout(this.timer);
        this.timer = null;
        this.image.stop();
    }

    move() {
        if(this.isBlocked) return;

        this.pivot.position.x = CircleSlider.radio;

        let generalRotation = Maths.lerp(0, this.angleLimit, this.progress) + this.angleOffset;   
        const progressRotation = Maths.normalize(this.angleEnd, this.angleStart, generalRotation)
       
        const progressNormalize = progressRotation <= .5 ? 
            Maths.normalize(.5, 0, progressRotation) :
            Maths.normalize(.5, 1, progressRotation);

        const progressInvNormalize = progressRotation <= .5 ? 
            Maths.normalize(0, .5, progressRotation) :
            Maths.normalize(1, .5, progressRotation);

        const offsetRotation = progressRotation <= .5 ? 
            this.angleLimit * progressInvNormalize * .3:
            -this.angleLimit * progressInvNormalize * .3;
        
        if(generalRotation > this.angleEnd || generalRotation < this.angleStart) {
            this.hideItem(generalRotation);
            return;
        } else {
            this.showItem(generalRotation);

            if(this.progress > 0 && this.progress < 1 && CircleSlider.getInstance().enabled) {
                if(isSmartphone) CircleSlider.getInstance().playVideo(this.image, this.indice);
                if(CircleSlider.getInstance().hasSpeed) Header.changeTitle(this.title, this.url);
            }
        }

        generalRotation = generalRotation + offsetRotation;

        const scaleAll = Maths.lerp(.8, 1.5, CircleSlider.easing(progressNormalize));
        const z = Maths.lerp(-300, 100, progressNormalize);

        const scale = Maths.lerp(.2, 1, progressNormalize);//Maths.lerp(0, 4, CircleSlider.easing(Math.abs(progressRotation) * .5)); 
        const center = Maths.lerp(.7, .3, progressRotation);

        if(this.image) {
            this.image.material.uniforms.imageScale.value = scale;
            this.image.material.uniforms.scaleCenter.value = center;

            this.pivot.scale.x = scaleAll;
            this.pivot.scale.y = scaleAll * CircleSlider.getInstance().scaleImage;

            this.group.rotation.z = generalRotation;
            this.group.position.y = (Metrics.WIDTH * .02) * progressInvNormalize;
            this.image.position.z = z;
            this.pivot.rotation.z = -this.group.rotation.z;

           
        }
    }

    dispose() {
        super.dispose();
    }

    resize() {
        super.resize();
                    
        if(this.image) {
            if(Metrics.WIDTH < Sizes.SMARTPHONE) {
                this.modSpeed = .8;
            } else {
                this.modSpeed = 2.859;
            }
            
            this.image.resize();

            const ratio = Metrics.WIDTH / Metrics.HEIGHT;
            
            this.xImageOffset = this.xImage * .5;

            this.modAspectRatio = 0.5 + (ratio - 1.0) * ((1.0 - 0.5) / (1.6 - 1.0));
            this.modAspectRatio = Math.max(0.5, ratio * .5);
            this.offsetPositionY = .55 + (this.modAspectRatio - .5) * .25;

            this.pivot.position.x = CircleSlider.getInstance().radio;
        }
    }
}